export default "__VITE_ASSET__DSgmyh5a__"